import React from 'react';

import { Field } from '../field/field';
import './dropdown.scss';

export const Dropdown = ({ options, optionValue, optionLabel, onChange }) => {
  return (
    <Field tag="select" className="rc-field--dropdown rc-field--dropdown--size-ss" onChange={onChange}>
      {options.map((option, index) => (
        <option key={index} value={option[optionValue]}>
          {option[optionLabel]}
        </option>
      ))}
    </Field>
  );
};

Dropdown.defaultProps = {
  options: []
};
